module.exports = __webpack_public_path__ + "static/media/chat.76631dd8.mp3";